import { ComponentProps, FC } from 'react';
import { useTranslation } from 'next-i18next';
import { BannerBox } from '../../box/BannerBox';
import { VariationIcon } from '../VariationIcon/VariationIcon';

export const ConversionUnderPriceBanner: FC<ComponentProps<typeof BannerBox>> = ({ recommendedPrice, ...props }) => {
  const { t } = useTranslation('price-drop');

  return (
    <BannerBox
      variant="success"
      recommendedPrice={recommendedPrice}
      title={t('PRICE_DROP.PRICE_ZONE.CONVERSION.WELL_PRICE.TITLE')}
      titleIcon={<VariationIcon name={'success'} />}
      description={t('PRICE_DROP.PRICE_ZONE.CONVERSION.WELL_PRICE.INFO', {
        formattedRecommendation: recommendedPrice,
      })}
      showLearnMoreButton={true}
      {...props}
    />
  );
};
